import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { AgendaStore, AgendaState } from './agenda.store';
import { Observable } from 'rxjs';
import { Agenda } from '@state/agenda/agenda.model';
import { map } from 'rxjs/operators';
import { Moment } from 'moment';

@Injectable({ providedIn: 'root' })
export class AgendaQuery extends QueryEntity<AgendaState> {

    constructor(protected store: AgendaStore) {
        super(store);
    }

    getCurrentAgenda(): Agenda {
        return this.getValue().currentAgenda;
    }

    getMovingAgenda(): Agenda {
        return this.getValue().movingAgenda;
    }

    selectCurrentAgenda(): Observable<Agenda> {
        return this.select('currentAgenda');
    }

    selectMovingAgenda(): Observable<Agenda> {
        return this.select('movingAgenda');
    }

    getOpeningTime(): Moment {
        return this.getValue().openingTime;
    }

    getClosingTime(): Moment {
        return this.getValue().closingTime;
    }

    /**
     * @see https://momentjs.com/docs/#/get-set/day/
     */
    getIsWeekday(): boolean {
        return this.getValue().currentMoment.day() > 0 && this.getValue().currentMoment.day() < 6;
    }

    /**
     * @see https://momentjs.com/docs/#/get-set/day/
     */
    selectIsWeekday(): Observable<boolean> {
        return this.select('currentMoment').pipe(map(currentMoment => currentMoment.day() > 0 && currentMoment.day() < 6));
    }
}
